import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useFocusVisible } from "use-focus-visible";
import { KeyBoardKeys } from "../../../types";
import { StyledTrigger } from "./trigger.styles";
export function Trigger({ value, isOpened, onClick, outlined, hasInitialSelectionChanged, }) {
    const { focusVisible, onFocus, onBlur } = useFocusVisible();
    const handler = useCallback((e) => {
        if (e.key === KeyBoardKeys.Enter ||
            e.key === KeyBoardKeys.Space ||
            e.key === " " ||
            e.key === KeyBoardKeys.ArrowDown) {
            e.preventDefault();
            onClick();
        }
    }, []);
    return (_jsx(StyledTrigger, Object.assign({ tabIndex: 0, focusVisible: focusVisible, onFocus: onFocus, onBlur: onBlur, onKeyUp: handler, outlined: outlined, onClick: onClick, opened: isOpened, hasInitialSelectionChanged: hasInitialSelectionChanged, "data-testid": "dropdown-selectcustom-trigger" }, { children: _jsx("div", { children: value }) })));
}
